var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"recovery section-padding bg-gradient",staticStyle:{"min-height":"100vh"},attrs:{"id":"recovery","data-midnight":"white"}},[_c('b-row',{staticClass:"mx-auto"},[_c('b-col',{staticClass:"mx-auto",attrs:{"cols":"8"}},[_c('b-card',[_c('reset-password')],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }